<template>
  <div class="grm-simple-select-component">
    <div class="grm-simple-select-wrapper">
      <select class="grm-simple-select" @input="$emit('input', $event.target.value)">
        <option v-for="(option, i) in options" :key="i" :value="option.value" :selected="option.value == value">{{ option.title }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrmSimpleSelect',
  props: {
    options: { type: Array,  default: () => [] },
    value: { type: [String, Number] },
  },
}
</script>

<style lang="scss" scoped>
.grm-simple-select-component {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.grm-simple-select-wrapper {
  height: max-content;
  position: relative;
  &::before {
    content: '';
    width: 8px;
    height: 100%;
    background: url('~@/assets/images/arrowLineThickDown.svg') no-repeat center / 100% auto;
    position: absolute;
    right: 10px;
    pointer-events: none;
    z-index: 1;
  }
}
.grm-simple-select {
  border: none;
  border-radius: 20px;
  padding: 0 24px 0 10px;
  background-color: #eee;
  font-size: 12px;
  color: #333;
  line-height: 24px;
  appearance: none;
}
</style>
